import { LanguageCode } from '../../core/i18n/languages';

export type LoginTextKey =
  | 'caseNumberHint'
  | 'caseNumberPlaceholder'
  | 'checkCaseStatus'
  | 'debtorNotFound'
  | 'loginWithBankId'
  | 'or'
  | 'seeStatusAndAmount'
  | 'welcome';

export const loginTranslations: Record<LanguageCode, Record<LoginTextKey, string>> = {
  no: {
    caseNumberHint: 'Du finner saksnummeret i brevet du fikk tilsendt',
    caseNumberPlaceholder: 'F.eks. 100001',
    checkCaseStatus: 'Sjekk saksstatus',
    debtorNotFound: 'Skyldner ikke funnet.',
    loginWithBankId: 'Logg inn med BankID',
    or: 'Eller',
    seeStatusAndAmount: 'Se status og beløp',
    welcome: 'Velkommen',
  },
  se: {
    caseNumberHint: 'Du hittar ärendenumret i brevet du fick',
    caseNumberPlaceholder: 'T.ex. 100001',
    checkCaseStatus: 'Kontrollera ärendestatus',
    debtorNotFound: 'Gäldenären hittades inte.',
    loginWithBankId: 'Logga in med BankID',
    or: 'Eller',
    seeStatusAndAmount: 'Se status och belopp',
    welcome: 'Välkommen',
  },
  en: {
    caseNumberHint: 'You can find the case number in the letter you received',
    caseNumberPlaceholder: 'E.g. 100001',
    checkCaseStatus: 'Check case status',
    debtorNotFound: 'Debtor not found.',
    loginWithBankId: 'Log in with BankID',
    or: 'Or',
    seeStatusAndAmount: 'See status and amount',
    welcome: 'Welcome',
  },
  dk: {
    caseNumberHint: 'Du finder sagsnummeret i brevet du modtog',
    caseNumberPlaceholder: 'F.eks. 100001',
    checkCaseStatus: 'Tjek sagsstatus',
    debtorNotFound: 'Skyldner ikke fundet.',
    loginWithBankId: 'Log ind med BankID',
    or: 'Eller',
    seeStatusAndAmount: 'Se status og beløb',
    welcome: 'Velkommen',
  },
  es: {
    caseNumberHint: 'Encontrará el número de caso en la carta que recibió',
    caseNumberPlaceholder: 'P. ej. 100001',
    checkCaseStatus: 'Comprobar el estado del caso',
    debtorNotFound: 'Deudor no encontrado.',
    loginWithBankId: 'Iniciar sesión con BankID',
    or: 'O',
    seeStatusAndAmount: 'Ver estado e importe',
    welcome: 'Bienvenido',
  },
  ar: {
    caseNumberHint: 'يمكنك العثور على رقم الحالة في الرسالة التي تلقيتها',
    caseNumberPlaceholder: 'مثلاً 100001',
    checkCaseStatus: 'التحقق من وضع الحالة',
    debtorNotFound: 'لم يتم العثور على المدين.',
    loginWithBankId: 'تسجيل الدخول باستخدام BankID',
    or: 'أو',
    seeStatusAndAmount: 'عرض الحالة والمبلغ',
    welcome: 'مرحبًا',
  },
};
